import { Box, Container, Typography, Button } from '@mui/material';
import ErrorImg from '@assets/images/backgrounds/delete-404.svg';

/*Helpers*/
import { logout } from '@utility/function/logout';
const accessToken = localStorage.getItem('accessToken');

const DeleteEvent = () => (
  <Box
    display="flex"
    flexDirection="column"
    height="100vh"
    textAlign="center"
    justifyContent="center"
  >
    <Container maxWidth="md">
      <img src={ErrorImg} alt="404" />
      <Typography align="center" variant="h1" mb={4}>
        Rất tiếc
      </Typography>
      <Typography align="center" variant="h4" mb={4}>
        Sự kiện của bạn đã bị xóa, vui lòng liên hệ BTC để biết thêm thông tin chi tiết
      </Typography>
      {accessToken && (
        <Button color="primary" variant="contained" onClick={() => logout()} disableElevation>
          Đăng xuất
        </Button>
      )}
    </Container>
  </Box>
);

export default DeleteEvent;
